const requests = {
    diagrams: `/v1/playground-templates`,


    invitePeople: `/v1/invite`,
    sendFeedback: `/v1/requests/feedback`,
    sendRequest: `/v1/requests`,

};

export default requests;
